var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Select } from "antd";
import styles from "../HandFilter.module.scss";
import { useComponentLocale } from "../../../hooks/useComponentLocale";
import { sortedOrderPositions } from "../../../helpers/helpers";
import { getSpotPositions } from "../../utils";
var Option = Select.Option;
export var Position = function (_a) {
    var filter = _a.filter, onFilterApply = _a.onFilterApply, isHero = _a.isHero, librariesResponse = _a.librariesResponse, selectedTab = _a.selectedTab;
    var position = useMemo(function () {
        if (isHero === null) {
            var allPositions_1 = __spreadArray(__spreadArray([], filter.heroPos, true), filter.villainPos, true);
            return allPositions_1.filter(function (item, pos) { return allPositions_1.indexOf(item) == pos; });
        }
        return isHero ? filter.heroPos : filter.villainPos;
    }, [isHero, filter.heroPos, filter.villainPos]);
    var getLocale = useComponentLocale();
    var playerPosLocale = getLocale({ component: 'hands', section: 'playerPosition' });
    var positions = sortedOrderPositions(getSpotPositions(librariesResponse, selectedTab === 'report' ? filter.spotForReport : filter.spot));
    var onChangePosition = function (value) {
        if (isHero === null) {
            onFilterApply({ heroPos: value, villainPos: value });
        }
        else {
            onFilterApply(isHero ? { heroPos: value } : { villainPos: value });
        }
    };
    return (_jsx("p", { children: _jsx(Select, __assign({ mode: 'multiple', className: styles.select, placeholder: playerPosLocale, size: 'small', allowClear: true, value: position, onChange: onChangePosition, listHeight: 300 }, { children: positions.map(function (position, index) { return (_jsx(Option, __assign({ value: position }, { children: position }), "".concat(index))); }) })) }));
};
